export abstract class LookupModel {

    public abstract getCode();
    public abstract getDescription();

}
